// authentication module mutations
export const SET_AUTHENTICATE_RESOLVE = 'SET_AUTHENTICATE_RESOLVE'
export const SET_INITIALIZATION = 'SET_INITIALIZATION'
export const SET_INTERRUPTED_ROUTE = 'SET_INTERRUPTED_ROUTE'
export const SET_IS_CHALLENGE_REQUESTED = 'SET_IS_CHALLENGE_REQUESTED'

// CARD MODULE MUTATIONS
export const ADD_NEW_CARD = 'ADD_NEW_CARD'
export const SET_NEW_CARD_DATA = 'SET_NEW_CARD_DATA'
export const DELETE_NEW_CARD_DATA = 'DELETE_NEW_CARD_DATA'
export const SET_CARDS = 'SET_CARDS'
export const SET_CARD_AUTH_TOKEN = 'SET_CARD_AUTH_TOKEN'
export const DELETE_CARD = 'DELETE_CARD'
export const SET_PROVISIONING_DATA = 'SET_PROVISIONING_DATA'
export const RESET_PROVISIONING_DATA = 'RESET_PROVISIONING_DATA'
export const SET_UNPROVISIONED_CARDS = 'SET_UNPROVISIONED_CARDS'
export const DELETE_UNPROVISIONED_CARD = 'DELETE_UNPROVISIONED_CARD'
export const UPDATE_BILLING_ADDRESS = 'UPDATE_BILLING_ADDRESS'

// USER MODULE MUTATIONS
export const SET_REGISTRATION_DATA = 'SET_REGISTRATION_DATA'
export const SET_AUTHORIZATION = 'SET_AUTHORIZATION'
export const SET_CONSUMER = 'SET_CONSUMER'
export const SET_FLOW = 'SET_FLOW'
export const SET_IS_RECOGNIZED_USER = 'SET_IS_RECOGNIZED_USER'
export const SET_APP_INSTANCES = 'SET_APP_INSTANCES'
export const ADD_APP_INSTANCES = 'ADD_APP_INSTANCES'
export const SET_CALL_APP_INSTANCES = 'SET_CALL_APP_INSTANCES'
export const DELETE_APP_INSTANCE = 'DELETE_APP_INSTANCE'
export const SET_MARKETING_OPT_IN = 'SET_MARKETING_OPT_IN'
export const SET_COMPLIANCE_ACCEPTED_VERSION = 'SET_COMPLIANCE_ACCEPTED_VERSION'
export const SET_MOBILE_NUMBER = 'SET_MOBILE_NUMBER'
export const SET_MUST_REACCEPT = 'SET_MUST_REACCEPT'
export const SET_LOCALE = 'SET_LOCALE'
export const SET_LOCALE_SELECTOR_ACTIVE = 'SET_LOCALE_SELECTOR_ACTIVE'
export const SET_LOCALE_SELECTOR_SELECTED = 'SET_LOCALE_SELECTOR_SELECTED'
export const SET_LOCALE_VALIDATED = 'SET_LOCALE_VALIDATED'
export const SET_PREVIOUS_LOCALE = 'SET_PREVIOUS_LOCALE'
export const TRACK_EXPERIMENT = 'TRACK_EXPERIMENT'
export const SET_REGISTER_USER_PAYLOAD = 'SET_REGISTER_USER_PAYLOAD'
export const SET_ADD_BILLING_ADDRESS_PAYLOAD = 'SET_ADD_BILLING_ADDRESS_PAYLOAD'

// IDENTITY MODULE MUTATIONS
export const SET_USER_ID = 'SET_USER_ID'
export const SET_IDENTITY_TYPE = 'SET_IDENTITY_TYPE'
export const SET_LOOKUP_SESSION_ID = 'SET_LOOKUP_SESSION_ID'
export const SET_VERIFICATION_DATA = 'SET_VERIFICATION_DATA'
export const SET_VERIFICATION_CHANNEL_USED = 'SET_VERIFICATION_CHANNEL_USED'

// SHIPPING ADDRESS MUTATIONS
export const ADD_SHIPPING_ADDRESS = 'ADD_SHIPPING_ADDRESS'
export const SET_SHIPPING_ADDRESSES = 'SET_SHIPPING_ADDRESSES'
export const DELETE_SHIPPING_ADDRESS = 'DELETE_SHIPPING_ADDRESS'

// ROOT VUEX MUTATION
export const SET_APP_THEME = 'SET_APP_THEME'
export const SET_ANALYTICS_FEATURE = 'SET_ANALYTICS_FEATURE'
export const SET_INITIALIZED = 'SET_INITIALIZED'
export const SET_ACTION = 'SET_ACTION'
export const SET_SERVICE_LAYER_ERROR = 'SET_SERVICE_LAYER_ERROR'
export const SET_CORRELATION_ID = 'SET_CORRELATION_ID'
export const SET_MESSAGE_PAGE_CONTENT = 'SET_MESSAGE_PAGE_CONTENT'
export const SET_LATEST_POLICIES = 'SET_LATEST_POLICIES'
export const SET_MUST_ACCEPT_POLICY = 'SET_MUST_ACCEPT_POLICY'
export const SET_INTERCEPT_UNAUTHORIZED_ERROR = 'SET_INTERCEPT_UNAUTHORIZED_ERROR'
export const SET_SESSION_EXPIRED_NOTICE = 'SET_SESSION_EXPIRED_NOTICE'
export const SET_CONFIRMATION_MODAL_CONFIG = 'SET_CONFIRMATION_MODAL_CONFIG'
export const SET_ACTION_IS_PENDING = 'SET_ACTION_IS_PENDING'
export const SET_POST_LOGIN_PATH = 'SET_POST_LOGIN_PATH'
export const SET_SKIP_UNPROVISION = 'SET_SKIP_UNPROVISION'
export const SET_WEBAUTHN_INFO = 'SET_WEBAUTHN_INFO'
export const START_LOADER = 'START_LOADER'
export const STOP_LOADER_WITH_ID = 'STOP_LOADER_WITH_ID'
export const STOP_ALL_LOADERS = 'STOP_ALL_LOADERS'
export const START_LOADER_SUCCESS_ANIMATION = 'START_LOADER_SUCCESS_ANIMATION'
export const STOP_LOADER_SUCCESS_ANIMATION_WITH_ID = 'STOP_LOADER_SUCCESS_ANIMATION_WITH_ID'
export const STEP_MAP = 'STEP_MAP'
export const RESET_STEP_MAP = 'RESET_STEP_MAP'
